import React from 'react';
import { FormattedMessage } from 'react-intl';

import JumpButton from '../../JumpButton/JumpButton';

import DOMElementID from '../../../constants/DOMElementID';

const TableBodyJumpButtons = () => {
    return (
        <>
            <JumpButton
                key="skip2pagination"
                variant="flat"
                targetElementID={DOMElementID.FOOTER_PAGINATION_CONTAINER}
            >
                <FormattedMessage id={'layoutNavigation.skip2pagination'} />
            </JumpButton>
            <JumpButton
                key="back2header"
                variant="flat"
                targetElementID={DOMElementID.REPORT_HEADER}
            >
                <FormattedMessage id={'layoutNavigation.back2header'} />
            </JumpButton>
            <JumpButton
                key="back2menu"
                variant="flat"
                targetElementID={DOMElementID.SIDEBAR_MODIFY_REPORT}
            >
                <FormattedMessage id={'layoutNavigation.back2menu'} />
            </JumpButton>
        </>
    );
};

export default TableBodyJumpButtons;
